const findTeamPos = (competition, id) => competition.findIndex(team => team.teamId === id)

export {
  findTeamPos
}
